import { PROMO_TYPE_NORMAL, PROMO_TYPE_TACTICAL } from './constants';
import { NormalPromo } from './normal-promo/component';
import { TacticalAds } from './tactical-ads/component';
import type { Component } from './types';

export const AdPromoContent: Component = ({ item }) => (
  <div>
    { item?.promoType === PROMO_TYPE_TACTICAL
    && (
      <TacticalAds
        item={item} />
    )}
    { item?.promoType === PROMO_TYPE_NORMAL && (
      <NormalPromo item={item} />
    ) }
  </div>
);
